exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addModules_wrap_content .tox .tox-statusbar{display:none!important}.addModules_wrap_content .tox-tinymce{height:550px!important}.el-dialog,.el-form-item__label{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45be4c1b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = VpL/
// module chunks = 5